// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-shared-InstructionsToExtractors-module__Input webpack-concepts-Extraction-Blocks-shared-BlockWidgets-module__Input";
var _2 = "webpack-concepts-Extraction-Blocks-shared-InstructionsToExtractors-module__LabelText webpack-concepts-Extraction-Blocks-shared-BlockWidgets-module__LabelText";
var _3 = "webpack-concepts-Extraction-Blocks-shared-InstructionsToExtractors-module__LabelTextContainer";
export { _1 as "Input", _2 as "LabelText", _3 as "LabelTextContainer" }
